/**
 *  Copyright (c) 2022-present TVM Engineering Authors.
 *
 */
/* eslint-disable */
import React from "react";
import { makeStyles } from "@mui/styles";
import { Grid, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import authStyles from "../../theme/authStyles";
import STATIC_ROUTES from "../../route/STATIC_ROUTES";

const useStyles = makeStyles(authStyles);

export const NotFoundTypes = {
  index: "index",
  dashboard: "dashboard",
};

const NotFoundPage = React.memo(({ type }) => {
  const navigate = useNavigate();

  const classes = useStyles();
  console.log("the type", type);
  let content;

  if (type === NotFoundTypes.dashboard) {
    content = (
      <div
        className={classes.root}
        style={{ width: "100%", display: "flex", alignItems: "center" }}
      >
        <Grid container spacing={4} className={classes.alignAuthPage}>
          <Grid item xs={12}>
            <Typography variant="h1" component="h1">
              404
            </Typography>
            <Typography variant="h4" component="h4">
              This page could not be found.
            </Typography>
            <Typography component="p">
              We are sorry, the page you are looking for cannot be found!
            </Typography>
            <Typography component="p">
              <Button
                id="goToHomePage"
                variant="outlined"
                color="primary"
                className={classes.goBackButton}
                onClick={() => navigate(STATIC_ROUTES.dashboardHome)}
              >
                To The Home Page
              </Button>
            </Typography>
          </Grid>
        </Grid>
      </div>
    );
  } else {
    content = (
      <div className={classes.root}>
        <Grid container spacing={4} className={classes.alignAuthPage}>
          <Grid item xs={12}>
            <Typography variant="h1" component="h1">
              404
            </Typography>
            <Typography variant="h4" component="h4">
              This page could not be found.
            </Typography>
            <Typography component="p">
              We are sorry, the page you are looking for cannot be found!
            </Typography>
            <Typography component="p">
              <Button
                id="goToHomePage"
                variant="outlined"
                color="primary"
                className={classes.goBackButton}
                onClick={() => navigate(STATIC_ROUTES.landingPage)}
              >
                To The Home Page
              </Button>
            </Typography>
          </Grid>
        </Grid>
      </div>
    );
  }

  return content;
});

export default NotFoundPage;
